import { PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { CreateUserForm } from '~/features/CreateUserForm';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

/**
 * 利用者新規作成 Screen
 */
export const Screen: React.FC = () => (
  <div className={styles.screen}>
    <ClientSideMenu />
    <div className={styles.content}>
      <PageHeader
        variant='breadcrumb'
        breadcrumbItems={[{ label: '利用者', href: ROUTES.USERS }, { label: '新規追加' }]}
      />
      <main className={styles.body}>
        <Suspense fallback={<Shimmer />}>
          <CreateUserForm />
        </Suspense>
      </main>
    </div>
  </div>
);
